// extracted by mini-css-extract-plugin
export default {"submit-wrapper":"fUGwe_submit-wrapper","chat-B":"_jKOo_chat-B"};